/**
 * ...
 * @author Dmitri
 */
export enum CopilotResponseTags {
  COMPLETE = 'Complete',
  FAILED = 'Failed',
  ERROR = 'Error',
  WARNING = 'Warning',
  TIMEOUT = 'Timeout',
  UNKNOWN_INSTRUCTION = 'UnknownInstruction'
}
